import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IAddModulPayload, IAdvancedEditModulPayload, IEditModulPayload, IModul, IProgramLocatieModul } from './module.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ModuleService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;
    private listModuleURL =
        this.basePath +
        environment.interop.deps.nomenclatoare.module.list;
    private listDTModuleURL =
        this.basePath +
        environment.interop.deps.nomenclatoare.module.listDT;
    private addModulURL =
        this.basePath +
        environment.interop.deps.nomenclatoare.module.store;
    private updateModulURL =
        this.basePath +
        environment.interop.deps.nomenclatoare.module.update;
    private deleteModulURL =
        this.basePath +
        environment.interop.deps.nomenclatoare.module.delete;
    private findModulURL =
        this.basePath +
        environment.interop.deps.nomenclatoare.module.find;
    private listProgramLocatiiModulURL =
        this.basePath +
        environment.interop.deps.nomenclatoare.module.locatiiProgram;
    private advancedEditModulURL =
        this.basePath +
        environment.interop.deps.nomenclatoare.module.advancedEdit;

    constructor(private http: HttpClient) { }

    listModule() {
        return this.http
            .get<{ errors: boolean; data: IModul[]; status_code: number }>(
                this.listModuleURL
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get module:', error);
                    return throwError(error);
                })
            );
    }

    listDTModule() {
        return this.http.post(this.listDTModuleURL, {});
    }

    addModul(data: IAddModulPayload) {
        return this.http.post(this.addModulURL, data);
    }

    updateModul(data: IEditModulPayload) {
        return this.http.put(this.updateModulURL, data);
    }

    deleteModul(id: number) {
        return this.http.delete(this.deleteModulURL + id);
    }

    findModul(id: number) {
        return this.http.get(this.findModulURL + id);
    }

    listProgramLocatiiModul(id: number) {
        return this.http.get<{ errors: boolean; data: IProgramLocatieModul[]; status_code: number }>(
            this.listProgramLocatiiModulURL + id,
        ).pipe(
            map((response) => response.data),
            catchError((error) => {
                console.error('Error in get program locatii modul:', error);
                return throwError(error);
            })
        );;
    }

    advancedEditModul(data: IAdvancedEditModulPayload) {
        return this.http.put(this.advancedEditModulURL, data);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
